import type {
    ImageEditorCropMode,
    ImageEditorDimensions,
    ImageEditorExportFormat
} from './imageEditor';

export type WatermarkType = 'text' | 'logo';

export interface CropSelection
{
    x: number;
    y: number;
    width: number;
    height: number;
    active: boolean;
}

export interface CropperHistoryState
{
    id: string;
    label: string;
    cropSelection: CropSelection;
    cropMode: ImageEditorCropMode;
    aspectRatio: string;
    fixedSize: ImageEditorDimensions;
    circularSize: number;
    templateSize: ImageEditorDimensions | null;
    rotation: number;
    flipHorizontal: boolean;
    flipVertical: boolean;
    scale: number;
    brightness: number;
    contrast: number;
    saturation: number;
    grayscale: number;
    watermarkEnabled: boolean;
    watermarkText: string;
    watermarkType: WatermarkType;
    watermarkX: number;
    watermarkY: number;
    watermarkOpacity: number;
    watermarkSize: number;
    exportFormat: ImageEditorExportFormat;
    quality: number;
    outputResizeEnabled: boolean;
    outputSize: ImageEditorDimensions;
    optimizeDimensions: boolean;
}

export interface WebsiteLogoOption
{
    id: number;
    title: string;
    logoUrl: string;
}

export interface AspectRatioOption
{
    value: string;
    text: string;
    short?: string;
}

export interface CropperTemplate
{
    name: string;
    width: number;
    height: number;
}

export interface WatermarkPositionPreset
{
    title: string;
    icon: string;
    x: number;
    y: number;
}

export const cropperTemplates: CropperTemplate[] = [
    { name: 'article_thumb', width: 450, height: 250 },
    { name: 'gallery_thumb', width: 250, height: 250 },
    { name: 'main_slider_desktop', width: 1410, height: 705 },
    { name: 'main_slider_mobile', width: 370, height: 555 },
    { name: 'social_og', width: 1200, height: 630 }
];

export const defaultCropperAspectRatios: AspectRatioOption[] = [
    { value: '1', text: '[[[1:1 kwadrat]]]', short: '1:1' },
    { value: '1.333', text: '[[[4:3 standard]]]', short: '4:3' },
    { value: '1.777', text: '[[[16:9 panoramiczny]]]', short: '16:9' },
    { value: '0.75', text: '[[[3:4 portret]]]', short: '3:4' },
    { value: '0.5625', text: '[[[9:16 mobile]]]', short: '9:16' }
];

export const cropperWatermarkPositionPresets: WatermarkPositionPreset[] = [
    { title: '[[[Lewy górny]]]', icon: '↖', x: 15, y: 10 },
    { title: '[[[Prawy górny]]]', icon: '↗', x: 85, y: 10 },
    { title: '[[[Lewy dolny]]]', icon: '↙', x: 15, y: 90 },
    { title: '[[[Prawy dolny]]]', icon: '↘', x: 85, y: 90 },
    { title: '[[[Środek]]]', icon: '•', x: 50, y: 50 }
];
